import React from 'react';
import './eventsco.css'

const Eventsco = (props) => {
    return ( <>
    <div className='eventsco1'>
         <div className='featuredevents'>
        <img className='fepic' src={props.fepic} alt="" />
        <div className='fediv'>
            <div className='fediv2'>
                <h6 className='fet1'>{props.fet1}</h6>
                <h6 className='fet2'>{props.fet2}</h6>
                <h6 className='fet3'>{props.fet3}</h6>
            </div>
        </div>
    </div>
    </div>
   
    
    </> );
}
 
export default Eventsco;